import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { Skill } from '~/types/skill'
import { SkillDeleteDialog } from './components/skill-delete-dialog'
import { SkillDetailDialog } from './components/skill-detail-dialog'
import { SkillFormDialog } from './components/skill-form-dialog'
import { SkillsList } from './components/skills-list'

export function SkillsPage() {
  const { t } = useTranslation()
  const [selectedItem, setSelectedItem] = useState<Skill | null>(null)
  const [editingItem, setEditingItem] = useState<Skill | null>(null)
  const [deletingItem, setDeletingItem] = useState<Skill | null>(null)

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold" id="skills-title">
        {t('skills.title')}
      </h1>
      <SkillsList onViewDetail={setSelectedItem} />
      <SkillDetailDialog item={selectedItem} onEdit={setEditingItem} onDelete={setDeletingItem} />
      <SkillFormDialog editingItem={editingItem} />
      <SkillDeleteDialog deletingItem={deletingItem} />
    </div>
  )
}
